import { render, staticRenderFns } from "./TutorialVideos.vue?vue&type=template&id=38ec8a60&scoped=true&lang=pug&"
import script from "./TutorialVideos.vue?vue&type=script&lang=js&"
export * from "./TutorialVideos.vue?vue&type=script&lang=js&"
import style0 from "./TutorialVideos.vue?vue&type=style&index=0&id=38ec8a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ec8a60",
  null
  
)

export default component.exports